export const emailTemplate =
  "Merci de nous indiquer vos nom, prénom, email et numéro de téléphone ainsi que la date à laquelle vous souhaitez réserver ainsi que le nombre de personnes prévues.";
